import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import { Outlet, useNavigate } from 'react-router-dom';

const StudentLayout = () => {


  let navigate = useNavigate();
  useEffect(() => {
    const validateLogin = async () => {
      // Validate Login
      let token = localStorage.getItem("token");
      let user = localStorage.getItem("user");
      
      if (token && user) {
        try {
          const userData = JSON.parse(user);
          
          if (userData.userType === "student") {
            localStorage.setItem("username", userData.firstName || userData.email.split("@")[0]);
            localStorage.setItem("studentId", userData.userId || userData.student_id);
          } else {
            navigate("/login");
          }
        } catch (error) {
          navigate("/login");
        }
      } else {
        navigate("/login");
      }
    }

    validateLogin()
  }, [])

  return (
    <>
      <Navbar />
      <div className="main-content">
        <Sidebar role="student" />
        <div className="content-area">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default StudentLayout;
